module.exports = __webpack_public_path__ + "static/media/ios_en.bdb7879a.svg";